import React from 'react';
import { isLoggedIn, openLogin } from '../auth.js';
import { getSubscriptionStatus } from '../payments.js';

const ProtectedRoute = ({ children, requireSubscription = true }) => {
  if (!isLoggedIn()) {
    return (
      <div className="auth-required">
        <h3>Authentication Required</h3>
        <p>Please sign in to access this page.</p>
        <button onClick={openLogin} className="btn btn-primary">
          Sign In
        </button>
      </div>
    );
  }

  if (requireSubscription) {
    const subscriptionStatus = getSubscriptionStatus();
    
    if (!subscriptionStatus?.active || !subscriptionStatus?.notExpired) {
      return (
        <div className="subscription-required">
          <h3>Subscription Required</h3>
          <p>You need an active subscription to access this content.</p>
          <div className="subscription-status">
            <p><strong>Current Status:</strong></p>
            <ul>
              <li>Active: {subscriptionStatus?.active ? 'Yes' : 'No'}</li>
              <li>Not Expired: {subscriptionStatus?.notExpired ? 'Yes' : 'No'}</li>
              <li>Plan: {subscriptionStatus?.plan || 'None'}</li>
            </ul>
          </div>
          <p>
            <a href="/account" className="btn btn-primary">
              Manage Subscription
            </a>
          </p>
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
